export default __webpack_public_path__ + "static/media/Image-7.d97c652a.jpg";